import styled from 'styled-components';
import { rgba } from 'polished';
import { MAIN_BLACK } from '@/constants/colors';

export const Container = styled.div`
  position: relative;

  .episode-card {
    &__thumbnail {
      margin-bottom: 8px;
    }

    &__title {
      font-size: 1.6rem;
      line-height: 2.6rem;
      margin-bottom: 4px;
    }

    &__link {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
    }

    &__add-info {
      margin: 0 8px 0 0;
      padding: 0;
      color: ${rgba(MAIN_BLACK, 0.7)};
      list-style: none;
      display: inline-block;

      li {
        display: inline-block;
      }

      li:not(:last-of-type) {
        position: relative;
        padding-right: 20px;

        &::before {
          content: '';
          display: block;
          height: 4px;
          width: 4px;
          border-radius: 50%;
          background-color: ${rgba(MAIN_BLACK, 0.7)};
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -2px;
          margin-right: -2px;
        }
      }
    }
  }

  .thumbnail {
    position: relative;
    width: 100%;
    min-height: 100px;
    cursor: pointer;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;

    img {
      width: 100%;
      max-height: 186px;
      object-fit: cover;
    }

    .play-fake {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 70px;
      width: 70px;
      background-color: ${p => rgba(p.theme.palette.primary.main, 0.8)};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: ${p => p.theme.palette.primary.contrastText};
      text-indent: 3px;
    }
  }

  .show-more-text {
    &__controls {
      text-align: right;
    }

    &__btn {
      font-weight: 400;
      font-size: 1.64rem;
      line-height: 2.6rem;
      text-decoration: underline;

      svg {
        display: none;
      }
    }
  }

  &.episode-card {
    &--upcoming {
      .thumbnail {
        cursor: default;
      }
    }
  }
`;

export default Container;
